import React, { useState } from "react";
import { useSearchList } from "../../../hooks/ui";
import { Search } from "@vibe/core";
import { List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { CSSTransition } from "react-transition-group";
import { WorkspaceType } from "../../../types/workspace.list.interface";
import AddColumnBoardsListBig from "./AddColumnBoardsListBig";
import { WorkspaceIcon } from "@components/addItem/WorkspaceList";

interface AddColumnWorkspaceListBigProps {
  data: WorkspaceType[] | [];
  originColumnTitle: string;
  originColumnType: string;
  originColumnId: string;
  originBoard: string;
}

const AddColumnWorkspaceListBig = ({
  data,
  originColumnTitle,
  originColumnType,
  originColumnId,
  originBoard,
}: AddColumnWorkspaceListBigProps) => {
  const [search, setSearch] = useState("");
  const [activeMenu, setActiveMenu] = useState("main");
  const filteredItems = useSearchList(data, search, "name");

  return (
    <div className="relative w-full h-full">
      <CSSTransition
        in={activeMenu === "main"}
        unmountOnExit
        timeout={500}
        classNames="menu-primary"
      >
        <div className="menu">
          <div
            style={{ padding: "15px 8px 12px 8px" }}
            className="bg-[#FFFFFF] sticky top-0 z-[1] border-b border-[#C3C6D4] overflow-x-hidden"
          >
            <Search
              placeholder="Search Workspaces"
              onChange={(e) => {
                setSearch(e);
              }}
              size={"small"}
              value={search}
            />
          </div>
          <List
            sx={{
              width: "100%",
              bgcolor: "background.paper",
            }}
            className="!text-xs"
            component="nav"
          >
            {data.length > 0 &&
              filteredItems.map((workspace, index) => {
                return (
                  <div key={workspace.id}>
                    <ListItemButton
                      sx={{
                        "&:hover": {
                          bgcolor: "#E6E9EF",
                        },
                        borderRadius: "4px",
                      }}
                      className="relative"
                      onClick={() => {
                        setActiveMenu(workspace.id);
                        setSearch("");
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: "unset" }} className="!w-auto mr-2">
                        <WorkspaceIcon
                          workspace={workspace}
                          index={index}
                          containerSize={20}
                          iconSize={14}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: "0.875rem",
                          fontFamily: "Poppins",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        primary={`${workspace.name}`}
                      />
                    </ListItemButton>
                  </div>
                );
              })}
          </List>
        </div>
      </CSSTransition>

      {data.length > 0 &&
        data.map((workspace) => {
          return (
            <CSSTransition
              in={activeMenu === workspace.id}
              unmountOnExit
              timeout={500}
              classNames="menu-secondary"
              key={workspace.id}
            >
              <div className="menu">
                <AddColumnBoardsListBig
                  workspaceId={workspace.id}
                  workspaceName={workspace.name}
                  setActiveMenu={setActiveMenu}
                  originColumnTitle={originColumnTitle}
                  originColumnType={originColumnType}
                  originColumnId={originColumnId}
                  originBoard={originBoard}
                />
              </div>
            </CSSTransition>
          );
        })}
    </div>
  );
};

export default AddColumnWorkspaceListBig;
